import type { RootState } from 'store'

export const getCountry = (state: RootState) => state?.producer?.country
export const getTradeName = (state: RootState) =>
  state?.producer?.tradeName ?? ''
export const getRegistrationNumber = (state: RootState) =>
  state?.producer?.registrationNumber ?? ''
export const getVat = (state: RootState) => state?.producer?.vat ?? ''
export const getLegalEntity = (state: RootState) => state?.producer?.legalEntity
export const getAddress = (state: RootState) =>
  state?.producer?.postAddress ?? { address: '' }
export const getPostcode = (state: RootState) => state?.producer?.postCode ?? ''
export const getPhone = (state: RootState) => state?.producer?.phone ?? ''
export const getWebsite = (state: RootState) => state?.producer?.website ?? ''
export const getNoWebsite = (state: RootState) =>
  state?.producer?.noWebSite ?? ''
export const getLogo = (state: RootState) => state?.producer?.logo ?? ''
export const getLogoLoading = (state: RootState) =>
  state?.producer?.logoLoading ?? false
export const getEmail = (state: RootState) => state?.producer?.email ?? ''
export const getTranslations = (state: RootState) =>
  state?.producer?.translations ?? []
export const getLegalAddress = (state: RootState) =>
  state?.producer?.legalAddress
export const getLegalEntityForm = (state: RootState) =>
  state?.producer?.legalEntityForm
export const getBranchNumber = (state: RootState) =>
  state?.producer?.branchNumber ?? ''
export const getLegalName = (state: RootState) =>
  state?.producer?.legalName ?? ''
export const getFormDirty = (state: RootState) => state?.producer?.isDirty
export const getWritePolicy = (state: RootState) =>
  state?.producer?.writePolicy ?? {}
export const getSameAsLegalAddress = (state: RootState) =>
  state?.producer?.sameAsLegalAddress ?? false
export const getActivityCode = (state: RootState) =>
  state?.producer?.activityCode ?? ''

export const getRegistrationNumberError = (state: RootState) =>
  state?.producer?.errors?.registrationNumber
export const getVatError = (state: RootState) => state?.producer?.errors?.vat
export const getAddressError = (state: RootState) =>
  state?.producer?.errors?.postAddress
export const getPostcodeError = (state: RootState) =>
  state?.producer?.errors?.postCode
export const getPhoneError = (state: RootState) =>
  state?.producer?.errors?.phone
export const getWebsiteError = (state: RootState) =>
  state?.producer?.errors?.website
export const getEmailError = (state: RootState) =>
  state?.producer?.errors?.email
export const getLogoError = (state: RootState) => state?.producer?.errors?.logo
export const getLegalEntityFormError = (state: RootState) =>
  state?.producer?.errors?.legalEntityForm
export const getBranchNumberError = (state: RootState) =>
  state?.producer?.errors?.branchNumber
export const getLegalNameError = (state: RootState) =>
  state?.producer?.errors?.legalName
export const getTranslationsErrors = (state: RootState) =>
  state?.producer?.errors?.translations ?? []
export const getActivityCodeError = (state: RootState) =>
  state?.producer?.errors?.activityCode ?? ''
export const getLegalAddressError = (state: RootState) =>
  state?.producer?.errors?.legalAddress
